<template lang="pug">
  vm-prompt(vm-size="medium" @vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteCustomerConfirm(form)" :vm-action="true" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="false" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.form.$invalid },]")
      vm-col.separador-modal-btn(vm-justify="center", vm-align="center", vm-w=6)
        b-form-group
          vm-input(:placeholder='$t("customers.name_placeholder")' :danger="$v.form.name.$invalid && $v.form.name.$model" :danger-text="$t('validation.required', { attribute: $t('customers.name') })" v-model="form.name" :label='$t("customers.name")' required)
      vm-col.separador-modal-btn(vm-justify="center", vm-align="center", vm-w=6)
        b-form-group
          vm-input(:placeholder='$t("customers.contact_placeholder")' :danger="$v.form.contact.$invalid && $v.form.contact.$model" :danger-text="'Name must have at least 4 ' + $v.form.contact.$params.minLength + ' letters.'" v-model="form.contact" :label='$t("customers.contact")' required)
      vm-col.separador-modal-btn(vm-justify="center", vm-align="center", vm-w=6)
        b-form-group
          vm-input(:placeholder='$t("customers.phone_placeholder")' type="number" :danger="$v.form.phone.$invalid && $v.form.phone.$model" :danger-text="$t('validation.required', { attribute: $t('customers.phone') })" v-model="form.phone" :label='$t("customers.phone")' required)
      vm-col.separador-modal-btn(vm-justify="center", vm-align="center", vm-w=6)
        b-form-group
          vm-input(:placeholder='$t("customers.website_placeholder")' v-model="form.website" :label='$t("customers.website")')
      vm-col.separador-modal-btn(vm-justify="center", vm-align="center", vm-w=6)
        b-form-group
          vm-input(:placeholder='$t("customers.email_placeholder")' :danger="!$v.form.email.email" danger-text="Field is email" v-model="form.email" :label='$t("customers.email")' required)
      vm-col.separador-modal-btn(vm-justify="center", vm-align="center", vm-w=6)
        vm-input(type="password" icon='lock-outline' :placeholder='$t("users.password_placeholder")' :danger="$v.form.password.$invalid && typeof $v.form.password.$model !== 'undefined'" :danger-text="$v.form.password.minLength ? $v.form.password.required ? '' : $t('validation.required', { attribute: $t('users.password') }) : $t('validation.min.string', { attribute: $t('users.password'), min: 4 })" :description-text='isAdd ? "" : $t("users.leave_empty")' v-model="form.password" :label='$t("users.password")' required pass)
      vm-col.separador-modal-btn(vm-justify="center", vm-align="center", vm-w=6)
        vm-input(type="password" icon='lock-outline' :placeholder='$t("users.confirm_password_placeholder")' :danger="($v.form.confirm_password.$invalid) && (typeof $v.form.confirm_password.$model) !== 'undefined'" :danger-text="$t('validation.same', { attribute: $t('users.confirm_password'), other: $t('users.password') })" v-model="form.confirm_password" :label='$t("users.confirm_password")' required pass)
      vm-col.separador-modal-btn(vm-justify="center", vm-align="center", vm-w=6)
        b-form-group
          p.label-file  {{ $t("strings.image_logo") }}
          input(type="file" ref="file" @input="handleFileUpload()" accept="image/jpeg, image/x-png" :description-text='isAdd ? "" : $t("users.leave_empty_file")' :label='$t("users.logo_file")')
</template>

<script>
import { required, requiredIf, minLength, email, sameAs } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Customers')

export default {
  name: 'ModalCustomers',
  props: {
    form: {
      type: Object,
      edit: false
    },
    isAdd: {
      default: true,
      type: Boolean
    }
  },
  data () {
    return { file: null }
  },
  validations () {
    return {
      form: {
        name: {
          required
        },
        contact: {
          required
        },
        phone: {
          required
        },
        email: {
          required,
          email
        },
        password: {
          required: requiredIf((password) => {
            return this.isAdd
          }),
          minLength: minLength(4)
        },
        confirm_password: {
          required: requiredIf((confirmPassword) => {
            return this.form.password
          }),
          sameAsPassword: sameAs('password')
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'isModalVisible'
    ]),
    getTitle () {
      return this.isAdd ? this.$t('customers.add') : this.$t('customers.edit')
    }
  },
  methods: {
    ...mapActions([
      'addCustomer',
      'editCustomer',
      'deleteCustomer',
      'setModalVisible',
      'loadCatalog'
    ]),
    handleFileUpload () {
      this.file = this.$refs.file.files[0]
    },
    saveRecord () {
      this.isAdd ? this.addCustomer({ customer: this.form, file: this.file }) : this.editCustomer({ customer: this.form, file: this.file })
      this.file = []
    },
    async deleteCustomerConfirm (customer) {
      let t = this
      this.auxDeleteCustomer = () => {
        t.deleteCustomer(customer)
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { attribute: this.$t(customer.contact) }),
        accept: this.auxDeleteCustomer
      })
    },
    autoCompleteFunc (value) {
      let payload = {}
      let column = value.target.parentElement.parentElement.getAttribute('column')
      let param = value.srcElement.value
      payload.url = value.target.parentElement.parentElement.getAttribute('url')
      payload.filter = `?${column}=${param}*&order_by=${column},asc`
      this.loadCatalog(payload)
    },
    close () {
      this.setModalVisible(false)
    }
  }
}
</script>
<style lang="scss" scoped>
.separador-modal-btn {
  padding-right: 10px;
}.label-file {
    padding-left: 5px;
    font-size: .85rem;
    color: rgba(0,0,0,.7);
}
</style>
